<template lang="pug">
.theindex-category
  Err404(v-if="!category")
  .cat-content(v-else)
    TheIndexHeader(:showBreadcrumbs="!rogue.isApp()")
    Hero(
      v-if="!rogue.isApp()"
      :image="category.img"
      :headline="category.headline || category.name"
      :subtitle="category.headline ? '' : featuredPost.title.rendered"
    )
    .headline(v-if="rogue.isApp()")
    .main-container.nav-bar
      .filters
        CategoryNav.category-nav(v-if="!rogue.isApp()")
        .filler
        .search-field
          RogueInput#index-category-search.search(:placeholder="__(`Search ${category.name}`)" v-model="query" @keyup.enter="search()")
          .search-btn.btn(@click.stop="search()")
            Icon(name="search")
      .clear-search(v-if="searchFor")
        h3
          | {{ __('Search results for:') }}&nbsp;
          | {{searchFor}}
        .clear-search-btn(@click="search('')")
          Icon.icn(name="x" color="#333")
    .main-container
      PostsGrid(:query="{categories: category.id, search: searchFor}" :category-name="category.name" :limit="9" :ssr="true" :show-filters="true")
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'
import { INDEX_CATEGORIES } from './data'
import CategoryNav from './components/category-nav.vue'
import TheIndexHeader from './components/header.vue'
import Hero from './components/hero.vue'
import PostsGrid from './components/posts-grid.vue'
import { useIndexSearch } from './helpers/search'
import metadata, { type MetadataType } from '@/js/helpers/metadata'
import { useRogue } from '@/js/services/Rogue'

const route = useRoute()
const rogue = useRogue()

const { query, searchFor, search, selectedCategory } = useIndexSearch()

const category = computed(() => INDEX_CATEGORIES.find(c => c.slug === route.params.category))

selectedCategory.value = category.value?.id || null

const head = computed<MetadataType>(() => ({
  title  : rogue.__(category.value?.name),
  robots : 'all',
  url    : rogue.localizedBaseURL + route.path,
}))

const headControl = useHead(metadata(head.value, rogue))

function updateHead() {
  headControl.patch(metadata(head.value, rogue))
}

watch(() => route.params.category, updateHead)

onBeforeUnmount(() => {
  headControl.dispose()
})

watch(() => route.query.q, (newVal) => {
  searchFor.value = newVal as string || ''
  query.value = newVal as string || ''
}, {
  immediate: true,
})

</script>

<style lang="scss" scoped>
.hero {
  margin-bottom: $space-xxl;
}
.headline {
  margin-top: 24px;
}

.nav-bar {
  margin-bottom: $space-m;
}

.category-nav.cat-link-wrapper {
  margin-bottom: $space-m;

  @include not-mobile() {
    margin-top: $space-xs;
    margin-bottom: $space-xs;
    margin-right: $space-xs;
  }
}

.filters {
  margin-bottom: $space-m;
  display: flex;
  justify-content: space-between;

  @include mobile(){
    flex-direction: column;
  }
}

.search-field {
  position: relative;

  :deep(){
    input{
      padding-right: $space-xl;
    }
  }

  .field{
    margin-bottom: 0;
  }
}

.search {
  min-width: 250px;
}

.search-btn {
  position: absolute;
  top: 0;
  right: 4px;
  padding: 12px 8px;
  cursor: pointer;
}

.clear-search {
  margin-bottom: $space-l;
  display: flex;
  align-items: center;

  h3 {
    margin-bottom: 0;
  }
}

.clear-search-btn {
  cursor: pointer;
  margin-left: $space-s;
  .icn {
    height: 14px;
    width: 14px;
  }
}
</style>
